import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import moment from 'moment';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContentText from '@material-ui/core/DialogContentText';
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';

import indigo from '@material-ui/core/colors/indigo';

import { ConfirmDialog } from 'components/admin/Dialogs';
import {
  Detail,
  Header,
} from './Dialog';
import {
  startAddTimecard,
  startEditTimecard,
  startRemoveTimecard
} from '../../../store/actions/timecards';
import {
  helpDispatch,
  Tooltip,
  TooltipTypes,
} from 'components/admin/Help';

const styles = theme => ({
  rootContent: {
    backgroundColor: indigo[50],
  },
  title: {
    backgroundColor: indigo[800],
  },
  dialogActions: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
});

const validate = (service) => {
  const errors = {};
  const requiredFields = [ ];
  requiredFields.forEach(field => {
    if (!service[field]) {
      errors[field] = 'Required';
    }
  });

  const validation = { errors, isInvalid: !!Object.keys(errors).length };
  validation.validateField = function (field) {
      return this.errors[field];
  };

  return validation;
}

class TimecardDialog extends Component {
  constructor(props) {
    super(props);
    const { timecardData } = props;

    if (timecardData === undefined) {
      this.state = {
        timecard: {
          startDate: (new Date()).getTime(),
          endDate: (new Date()).getTime(),
          notes: "",
        },
        showDelete: false,
      };
    } else {
      this.state = {
        timecard: {...timecardData},
        showDelete: false,
      };
    }

  }

  handleChange (propertyName, value) {
    this.setState(function(prevState, props){

      //TODO: refactor, quick hack to get the dialog functional. only differences
      //between the first two cases is the assignment for timePart and date being
      //set in state
       if (propertyName === "startDate") {
         const oldDate = moment(prevState.timecard.startDate);
         const newDate = moment(value);
         const datePart = newDate.format("YYYY-MM-DD");
         const timePart = oldDate.format("HH:mm:ss");
         const result = moment(`${datePart}T${timePart}`, moment.ISO_8601);
         const endTimePart = moment(prevState.timecard.endDate).format("HH:mm:ss");
         const endDateTime = moment(`${datePart}T${endTimePart}`, moment.ISO_8601);

         return {
           timecard: {
             ...prevState.timecard,
             startDate: result.valueOf(),
             endDate: endDateTime.valueOf(),
           }
         }
       } else if (propertyName === "startTime" ) {
         const oldDate = moment(prevState.timecard.startDate);
         const newDate = moment(value);

         const datePart = oldDate.format("YYYY-MM-DD");
         const timePart = newDate.format("HH:mm:ss");

         const result = moment(`${datePart}T${timePart}`, moment.ISO_8601);

         return {
           timecard: {
             ...prevState.timecard,
             startDate: result.valueOf(),
           }
         }
       } else if (propertyName === "endTime") {
         const oldDate = moment(prevState.timecard.startDate);
         const newDate = moment(value);

         const datePart = oldDate.format("YYYY-MM-DD");
         const timePart = newDate.format("HH:mm:ss");

         const result = moment(`${datePart}T${timePart}`, moment.ISO_8601);

         return {
           timecard: {
             ...prevState.timecard,
             endDate: result.valueOf(),
           }
         }
       } else if (propertyName === "clientJobId") {
         return {
           timecard: {
             ...prevState.timecard,
             clientId: value.clientId,
             projectId: value.projectId,
           }
         }
      } else {
         return {
           timecard: {
             ...prevState.timecard,
             [propertyName]: value,
           }
         }
       }
    });
  }

  handleCancel = () => {
    this.setState({ showDelete: false });
  }

  handleDelete = () => {
    const { startRemoveTimecard, handleClose } = this.props;
    const { timecard } = this.state;
    startRemoveTimecard(timecard.id)
      .then(() => handleClose());
  }

  render() {
    const {
      classes,
      show,
      type,
      handleClose,
      startAddTimecard,
      startEditTimecard,
    } = this.props;
    const { timecard, showValidation, showDelete, validation } = this.state;

    return(
      <div>
        <ConfirmDialog
          open={showDelete}
          title="Delete Timecard"
          contentText="This action will delete the timecard. Proceed?"
          handleCancel={this.handleCancel}
          handleOk={this.handleDelete}
        />
        <Dialog
          maxWidth="md"
          open={show}
          onClose={handleClose}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle className={classes.title}>
            <Header title="Time Card" />
          </DialogTitle>
          <DialogContent classes={{root: classes.rootContent}}>
            <Tooltip type={TooltipTypes.TIMECARD_REVIEW} placement="top">
              <Detail
                showValidation={showValidation}
                validation={validation}
                timecard={timecard}
                handleChange={this.handleChange.bind(this)}
              />
            </Tooltip>
          </DialogContent>
          <DialogActions className={classes.dialogActions}>
            {type !== "add" &&
              <Button onClick={() => this.setState({ showDelete: true })}>
                Delete
              </Button>
            }
            {type === "add" &&
              <div />
            }
            <div>
              <Button onClick={handleClose} color="primary">
                Cancel
              </Button>
              <Tooltip type={TooltipTypes.TIMECARD_SAVE} placement="left">
                <Button
                  onClick={() => {
                    const validation = validate(timecard);
                    if (validation.isInvalid) {
                      this.setState({
                        showValidation: true,
                        validation,
                      });
                    } else {
                      if (type === "add") {
                        startAddTimecard(timecard)
                          .then(() => handleClose())
                      } else {
                        const { id, ...updates } = timecard;
                        startEditTimecard(id, updates)
                          .then(() => handleClose())
                      }
                      helpDispatch();
                    }
                  }}
                  color="primary">
                  {type === "add" ? "Add" : "Done"}
                </Button>
              </Tooltip>
            </div>

          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

const mapDispatchToProps = {
  startAddTimecard,
  startEditTimecard,
  startRemoveTimecard,
};

export default compose(
  withStyles(styles),
  connect(null, mapDispatchToProps)
)(TimecardDialog);

//export default connect(null, mapDispatchToProps)(TimecardDialog);



// WEBPACK FOOTER //
// ./src/components/admin/Timecards/TimecardDialog.jsx